import React from 'react';
export function Footer() {
  return <footer className="bg-cream-dark py-12 border-t border-cream-dark text-center px-4" data-id="element-186">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-187">
        <p className="text-green font-bold text-lg" data-id="element-188">
          Mega Pack Industrialización de Alimentos en el Aula
        </p>
        <p className="text-slate text-sm" data-id="element-189">
          Material educativo para docentes técnicos de Latinoamérica
          <br data-id="element-190" />
          Hecho por especialistas, para docentes de todo el mundo
          hispanohablante.
        </p>
        <div className="flex justify-center gap-4 text-xs text-slate/80 pt-4" data-id="element-191">
          <a href="#" className="hover:text-terracota" data-id="element-192">
            Términos y condiciones
          </a>
          <a href="#" className="hover:text-terracota" data-id="element-193">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-terracota" data-id="element-194">
            Política de devoluciones
          </a>
          <a href="#" className="hover:text-terracota" data-id="element-195">
            Contacto y soporte
          </a>
        </div>
        <p className="text-slate/60 text-xs pt-4" data-id="element-196">
          © {new Date().getFullYear()} Mega Pack Industrialización de Alimentos
          en el Aula — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}